import React, {Component, ReactElement} from 'react'
import {SessionStorageHelper} from '../../../SessionStorageHelper'
import {Nullable} from '../../../app/TypeHelpers'
import {createResidentPage, ResidentPagePropsSet} from '../../../components/shared/hoc/createResidentPage'
import NatSsoRepo, {PostSsoLoginParams} from './repository/NatSsoRepo'
import {getQueryParameter, NatAsyncCallFunction} from '../../common/util/Natutil'
import {Data as ResidentSsoLoginInfo, NatPostResidentSsoLogin} from './repository/NatPostResidentSsoLogin'
import {
    NatResidentLoginInfoSessionStorageHelper,
} from '../../common/authentication/NatResidentLoginInfoSessionStorageHelper'
import {Location} from 'react-router-dom'

const KEY_SSO_LOGIN_CONDOMINIUM_CD = 'ssoLoginCondominiumCd';
const KEY_SSO_LOGIN_RIDGE_CD = 'ssoLoginRidgeCd';
const KEY_SSO_LOGIN_ROOM_NUMBER = 'ssoLoginRoomNumber';
const KEY_SENI_URL = 'seniUrl';
const KEY_SENI_TYPE = 'seniType';
const SENI_TYPE_MYPAGE = 'seniTypeMypage';
const SENI_TYPE_OTHER = 'seniTypeOther';
const SENI_TYPE_CONDOMINIUM_SELECTION = 'seniTypeCondominiumSelection';

interface Props {
    location: Location
    ssoRepo: NatSsoRepo
}

class NatResidentSsoLoginRedirectPage extends Component<Props & ResidentPagePropsSet> {

    ssoLoginCondominiumCd: Nullable<string>;
    ssoLoginRidgeCd: Nullable<string>;
    ssoLoginRoomNumber: Nullable<string>;
    seniUrl: Nullable<string>;
    seniType: Nullable<string>;

    constructor(props: Readonly<Props & ResidentPagePropsSet>) {
        super(props);

        this.ssoLoginCondominiumCd = SessionStorageHelper.getStringItemOrNull(KEY_SSO_LOGIN_CONDOMINIUM_CD);
        this.ssoLoginRidgeCd = SessionStorageHelper.getStringItemOrNull(KEY_SSO_LOGIN_RIDGE_CD);
        this.ssoLoginRoomNumber = SessionStorageHelper.getStringItemOrNull(KEY_SSO_LOGIN_ROOM_NUMBER);
        this.seniUrl = SessionStorageHelper.getStringItemOrNull(KEY_SENI_URL);
        this.seniType = SessionStorageHelper.getStringItemOrNull(KEY_SENI_TYPE);

        this.transitionLoginPage = this.transitionLoginPage.bind(this);
        this.ssoLogin = this.ssoLogin.bind(this);
        this.setSessionStorageCommonItems = this.setSessionStorageCommonItems.bind(this);
    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading();
        try {
            const refreshToken: string = getQueryParameter('refresh_token', this.props.location.search);

            if (!refreshToken) {
                this.transitionLoginPage();
                return;
            }

            const postLoginSsoParams: PostSsoLoginParams = {
                refreshToken: refreshToken ? refreshToken : '',
                condominiumCd: this.ssoLoginCondominiumCd ? this.ssoLoginCondominiumCd : '',
                ridgeCd: this.ssoLoginRidgeCd ? this.ssoLoginRidgeCd : '',
                roomNumber: this.ssoLoginRoomNumber ? this.ssoLoginRoomNumber : '',
            };
            const ssoLoginInfo: Nullable<NatPostResidentSsoLogin> =
                await NatAsyncCallFunction(
                    this.props.ssoRepo.postSsoLogin.bind(
                        this.props.ssoRepo,
                        postLoginSsoParams), this.props.navigate);

            // セッションストレージを全削除
            SessionStorageHelper.removeAllItem();

            // SSO認証OKの場合
            this.ssoLogin(ssoLoginInfo);

        } catch (HttpError) {

            // SSO認証NGの場合
            this.transitionLoginPage();

        } finally {
            this.props.eventEmitter.closeLoading();
        }
    }

    ssoLogin(ssoLoginInfo: Nullable<NatPostResidentSsoLogin>):void {
        if (ssoLoginInfo && ssoLoginInfo.details !== null) {
            // SSO認証OKの場合

            // SessionStrage設定　共通保持項目
            this.setSessionStorageCommonItems(ssoLoginInfo.details);

            if (ssoLoginInfo.details.condominiumCd !== null) {
                // SessionStrage設定 物件特定時保持項目
                NatResidentLoginInfoSessionStorageHelper.setSessionStorageCondominiumInfo(ssoLoginInfo.details);
            }

            window.location.href = '/resident/loginRedirect';

        }
    }

    setSessionStorageCommonItems(residentSsoLoginInfo:ResidentSsoLoginInfo):void {
        NatResidentLoginInfoSessionStorageHelper.setSessionStorageUserInfo(residentSsoLoginInfo);

        if (residentSsoLoginInfo.condominiumCd) {
            if (this.seniUrl) {
                setSessionStorage(KEY_SENI_URL, this.seniUrl);
                setSessionStorage(KEY_SENI_TYPE, SENI_TYPE_OTHER);
            } else {
                setSessionStorage(KEY_SENI_TYPE, SENI_TYPE_MYPAGE);
            }
        } else {
            if (this.seniUrl) {
                setSessionStorage(KEY_SENI_URL, this.seniUrl);
            }
            setSessionStorage(KEY_SENI_TYPE, SENI_TYPE_CONDOMINIUM_SELECTION);
        }

        if (residentSsoLoginInfo.mailAddressPc) {
            NatResidentLoginInfoSessionStorageHelper.setSessionStorageMailAddressDomain(
                residentSsoLoginInfo.mailAddressPc);
        } else if (residentSsoLoginInfo.mailAddressMb) {
            NatResidentLoginInfoSessionStorageHelper.setSessionStorageMailAddressDomain(
                residentSsoLoginInfo.mailAddressMb);
        }
    }

    transitionLoginPage():void {
        if (this.seniUrl) {
            this.props.navigate('/resident/login?seniurl=' + this.seniUrl);
            return;
        } else {
            this.props.navigate('/resident/login');
            return;
        }
    }

    render(): Nullable<ReactElement> {
        return (
            <>
            </>
        )
    }
}

export default createResidentPage(NatResidentSsoLoginRedirectPage)

function setSessionStorage(key: string, value: any | null): void {
    if (value) {
        SessionStorageHelper.setItem(key, value);
    } else {
        SessionStorageHelper.setItem(key, '');
    }
}
